import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Tools/DynamicGrid";
import CheckToken from "../../_Login/CheckToken";
import { UserContext } from "../../App";
import fetchWithRetries from "../../Tools/FetchWithRetries";
import GetChoppers from "../Tools/ChoppersGetChoppers";

const Choppers = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    const [choppers, setChoppers] = useState([]);

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {

        fetchWithRetries(3, GetChoppers, (payload) => {
            let myChoppers = JSON.parse(payload).data;

            let chopperList = myChoppers.map(c => (
                {
                    ChopperID: c[0],
                    ChopperName: c[1],
                    CreatedByID: c[2],
                    CreatedByFirstName: c[3],
                    CreatedByLastName: c[4],
                    CreatedByUserName: c[5],
                    CreatedByEmail: c[6],
                    CreatedDate: c[7],
                    ModifiedDate: c[8],
                    ChopperModelID: c[9],
                    ChopperModelName: c[10],
                    ChopperModelManufacturerID: c[11],
                    ChopperModelManufacturerName: c[12],
                    ChopperModelAirCapacity: c[13],
                    ChopperModelInletWidth: c[14],
                    ChopperModelMotorHP: c[15],
                    ChopperModelMaxRPM: c[16],
                    ChopperModelLink: c[17],
                    MaterialTypeID: c[18],
                    MaterialTypeName: c[19],
                    MaterialTypeDutyID: c[20],
                    MaterialTypeDutyName: c[21],
                    MotorPositionID: c[22],
                    MotorPositionLetter: c[23],
                    MotorPositionDescription: c[24],
                    MotorPositionPath: c[25],
                    CutterHeadPositionID: c[26],
                    CutterHeadPositionLetter: c[27],
                    CutterHeadPositionDescription: c[28],
                    CutterHeadPositionPath: c[29],
                    CutterMountingArrangementID: c[30],
                    CutterMountingArrangementLetter: c[31],
                    CutterMountingArrangementDescription: c[32],
                    CutterMountingArrangementPath: c[33],
                    TrimRemovalMethodID: c[34],
                    TrimRemovalMethodLetter: c[35],
                    TrimRemovalMethodDescription: c[36],
                    TrimRemovalMethodPath: c[37],
                    MaterialThickness: c[38],
                    MaterialSpeed: c[39],
                    MaterialWidth: c[40],
                    InletDiameter: c[41],
                    AirflowThroughCutter: c[42],
                    BladesInCutter: c[43],
                    DesiredPieceSize: c[44],
                    CutterRotatingSpeed: c[45],
                    PressureLoss: c[46]
                }
            ));
            setChoppers(chopperList);
        });

    }, []);

    useEffect(() => {

        if (choppers.length > 0) {
            let rowsList = [];

            choppers.forEach((entry, index) => {

                let chopperID = entry["ChopperID"];
                let chopperName = entry["ChopperName"];

                let row = [
                    // { type: "text", content: { text: `${chopperID}` } }, // ChopperID
                    { type: "link", content: { text: `${chopperName}`, link: `/Choppers/Details/${chopperID}` } }, // Chopper Name   

                    { type: "text", content: { text: `${entry["ChopperModelManufacturerName"]} ${entry["ChopperModelName"]}` } }, // Chopper Model Brand, Name
                    
                    { type: "text", content: { text: `${entry["ChopperModelMotorHP"]}` } }, // Motor HP
                    { type: "text", content: { text: `${entry["ChopperModelMaxRPM"]}` } }, // Max RPM
                    { type: "text", content: { text: `${entry["ChopperModelInletWidth"]}` } }, // Inlet Width (in)
                    { type: "text", content: { text: `${entry["ChopperModelAirCapacity"]}` } }, // Air Capacity (CFM)
                    
                    { type: "text", content: { text: `${entry["CreatedByFirstName"]} ${entry["CreatedByLastName"]}` } }, // Created By FirstName LastName
                    { type: "text", content: { text: `${entry["CreatedDate"]}` } }, // Created Date
                    { type: "text", content: { text: `${entry["ModifiedDate"]}` } } // Modified Date
                    
                ];

                rowsList.push(row);
            });

            setColumns(["Chopper Name", "Manufacturer Model", "Motor HP", "Max RPM", "Inlet Width (in)", "Air Capacity (CFM)", "Created By", "Created Date", "Last Modified"]);
            setRows(rowsList);

        }
    }, [choppers]);

    document.title = "Trim Choppers";
    return (

        <>
            <div className="choppers">
                {user["email"] != undefined &&
                    <>
                        <div className="container" style={{ margin: "auto" }}>
                            <h2>Trim Choppers</h2>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                    <p><Link className="btn btn-primary" to="/Choppers/New">New Chopper</Link></p>
                                </div>
                            </div>

                            {columns && rows && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} defaultsortindex={8} descending={true} />}

                        </div>

                    </>
                }

            </div>
        </>
    );
}

export default Choppers;